<script lang="ts">
export default {
  name: 'CardHeader',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const headerClass = computed(() => cn('flex flex-col space-y-1.5 p-4', props.class));
</script>

<template>
  <div :class="headerClass">
    <slot />
  </div>
</template>
